import { combineReducers } from 'redux'

import consultaRemuneracaoADMRH from './consultaRemuneracaoADMRH/store'
import quadrosAtivosADMRH from './quadrosAtivosADMRH/store'
import consultaQuadroInativosADMRH from './consultaQuadroInativosADMRH/store'
import consultaPensionistasADMRH from './consultaPensionistasADMRH/store'
import consultaCedidosPeloMP from './consultaCedidosMP/store'
import consultaCedidosParaMP from './consultaCedidosParaMP/store'
import consultaMembrosFuncoesGratificadas from './consultaMembrosFuncoesGratificadas/store'
import consultaServidoresFuncoesGratificadas from './consultaServidoresFuncoesGratificadas/store'
import consultaServidoresEmTeletrabalho from './consultaServidoresEmTeletrabalho/store'
import consultaEstagiariosMP from './consultaEstagiariosMP/store'
import consultaCargosComissaoMP from './consultaCargosComissaoMP/store'
import consultaCargosVagosOcupadosMembros from './consultaCargosVagosOcupadosMembros/store'
import consultaCargosVagosOcupadosServidores from './consultaCargosVagosOcupadosServidores/store'
import consultaConcursoSelecoes from './consultaConcursoSelecoes/store'
import consultaProvimentosServidores from './consultaProvimentosServidores/store'
import consultaProvimentosMembros from './consultaProvimentosMembros/store'
import consultaVerbasIndenizatorias from './consultaVerabasIndenizatorias/store'
import consultaVerbasExerciciosAnteriores from './consultaVerbasExerciciosAnteriores/store'
import consultaVacancias from './consultaVacancias/store'
import detalhesExperienciaProfissional from './detalhesExperienciaProfissional/store'
import consultaCurriculos from './consultaCurriculos/store'
import detalhesEscolaridadeCurriculos from './detalhesEscolaridadeCurriculos/store'
import entidades from './store'

export default combineReducers({
    entidades,
    consultaRemuneracaoADMRH,
    quadrosAtivosADMRH,
    consultaQuadroInativosADMRH,
    consultaPensionistasADMRH,
    consultaCedidosPeloMP,
    consultaCedidosParaMP,
    consultaMembrosFuncoesGratificadas,
    consultaServidoresFuncoesGratificadas,
    consultaServidoresEmTeletrabalho,
    consultaEstagiariosMP,
    consultaCargosComissaoMP,
    consultaCargosVagosOcupadosMembros,
    consultaCargosVagosOcupadosServidores,
    consultaConcursoSelecoes,
    consultaProvimentosServidores,
    consultaProvimentosMembros,
    consultaVerbasIndenizatorias,
    consultaVerbasExerciciosAnteriores,
    consultaVacancias,
    detalhesExperienciaProfissional,
    consultaCurriculos,
    detalhesEscolaridadeCurriculos,
})
